import { useContext } from 'react';

import IntlProvider from './IntlProvider';

export default function useIntl() {
  return useContext(IntlProvider.Context);
}
